import { requestHelpers } from '../../helpers';

const actions = {
    GET_PRODUCTS: "GET_PRODUCTS",
    GET_PACKAGES: "GET_PACKAGES",
    SET_PRODUCTS: "SET_PRODUCTS",
    SET_PACKAGES: "SET_PACKAGES",
    REISSUE_PERMISSIONS: 'REISSUE_PERMISSIONS',
    GET_PROMOTIONS: "GET_PROMOTIONS",
    SET_PROMOTIONS: "SET_PROMOTIONS",
    ADDED_PROMOTION_TO_BASKET: "ADDED_PROMOTION_TO_BASKET",
};

// TEMPORARILY COMMENTED OUT
//
// function getPackages( network = null ) {
//     console.log('GET PACKAGES FIRED')
//     return ( dispatch ) => {
//         dispatch( {
//             type: actions.GET_PACKAGES,
//         } );
//
//         requestHelpers
//             .authenticatedGetRequest( `/transactions/packages`, { network_id: network } )
//             .then( ( response ) => {
//                 dispatch( {
//                     type: actions.SET_PACKAGES,
//                     packages: response.data,
//                 } );
//             } );
//     }
// }

//temporary fix

function getPackages(  ) {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_PACKAGES,
        } );

        requestHelpers
            .authenticatedGetRequest( `/transactions/packages` )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_PACKAGES,
                    packages: response.data,
                } );
            } );
    }
}

export function getProducts() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_PRODUCTS,
        } );

        requestHelpers
            .authenticatedGetRequest( `/transactions/products`,  )
            .then( ( response ) => {
                dispatch( {
                    type: actions.SET_PRODUCTS,
                    products: response.data,
                } );
            } );
    }
}

function reissuePermissions() {
    return ( dispatch ) => {
        requestHelpers
            .authenticatedPostRequest( '/authentication/token/reissue' )
            .then( ( response ) => {
                dispatch( {
                    type: actions.REISSUE_PERMISSIONS,
                    permissions: response.data.permissions,
                    token: response.data.token,
                } );
            } );
    };
}

function getPromotionPrices( email ) {
    return dispatch => {
        dispatch( {
            type: actions.GET_PROMOTIONS,
        } );
        requestHelpers
            .authenticatedPostRequest( "/transactions/pricing", { email_address: email } )
            .then( response => {
                dispatch( {
                    type: actions.SET_PROMOTIONS,
                    packages: response.data[ 'packages' ],
                    products: response.data[ 'products' ],
                } );
            } )
            .catch( err => console.log( err ) );
    };
}

function addedPromotionToBasket() {
    return dispatch => {
        dispatch( {
            type: actions.ADDED_PROMOTION_TO_BASKET,
            promotionAddedToBasket: false,
        } );
    };
}

module.exports = {
    actions,
    getProducts,
    getPackages,
    reissuePermissions,
    getPromotionPrices,
    addedPromotionToBasket,
};



// WEBPACK FOOTER //
// src/client/actions/transactions/purchases.js